module.exports = __webpack_public_path__ + "static/media/heart-red.7f32d7d5.svg";